import type { FaireProductEntity } from "../../entity_types/product";

export const p_b3bnu6sskt: FaireProductEntity = {
  token: "p_b3bnu6sskt",
  type: "product",
  name: "DIVINE WATERMELON TAMALITOZ CANDY 12 CT",
  brandToken: "b_3pi3q87y4r",
  brandName: "Sugarox Candy Studio LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/bfbc2ea57c8da373bfd014ef778c50524cde7df00feec76b878cf7f94c5448be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/212ab091b4a624ed51d99c9f484ca854c6bd5357a31083458015899c10f89a80.png",
    "https://cdn.faire.com/fastly/e4e59602f10bb7fb74bd40e4ccf8e6b0439ff1556ecfa8b47ccb815aafb73fcd.png",
    "https://cdn.faire.com/fastly/199aa1226ac6fd0775f98279b2698fcedf3e6b311c835d7aa05a1bd23a89eb88.png",
    "https://cdn.faire.com/fastly/03459fd06d7735f3f8f6cf353334d960fe694c81b115aa09272c1db598cc0362.jpeg",
    "https://cdn.faire.com/fastly/9bdc5ad7a99ce87c3ad838db20c6a1507f56da834e5b2f3193109eb8a1763cd0.jpeg",
    "https://cdn.faire.com/fastly/0402eefe69a4ae7de652e61cb62e661ae512f3c0920c84814852de5cd1e15e44.jpeg",
    "https://cdn.faire.com/fastly/1bc5499466e8f317dbccf2542ea135a37047bbf78e548b0c5e6c017f99f1e600.jpeg",
    "https://cdn.faire.com/fastly/c714b0d8863d730a557b32436351f67edfed10eb41b0e88c4b4a966a925af1ab.jpeg",
  ],
  priceDollars: 3.81,
  description:
    '•\tHandcrafted – made in small batches.\n•\tSpicy – made with our own blend of mild chili powder, dehydrated lime juice and a touch of sea salt.\n•\tNatural Ingredients – Colored with turmeric, beet powder, annatto & spirulina extract. Flavored with Natural Fruit flavors.\n\n"Non-GMO"/ "Free of Bioengineered Ingredients"\n"Vegan" / "Vegan Compliant" / "Made with 100% Vegan ingredients"\n"Allergen Free" / "Free of the top 9 Major Allergens" / "Produced in an Allergen-Free Facility"\n"Gluten Free" \n\nThis is what it tastes like to be sitting on the porch of a beautiful turn of the century hacienda, hidden in the jungles outside of Merida Yucatan, pampering yourself with plates fulls of juicy watermelon sprinkled with chili, fresh lime juice and sea salt.\n\nNaturally flavored and colored ribbon style candy filled with our own blend of mild chili powder, dehydrated lime juice and a touch of sea salt. \n\n',
  tags: [],
  msrpDollars: 6.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:05.746Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
